import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import bowser from 'yola-bowser';
import controlIds from '../constants/control-ids';
import previewGifs from '../constants/preview-gifs';
import attributes from '../constants/attributes';
import computeSpacingFallback from '../helpers/compute-spacing-fallback';

const { Paragraph } = designSystem;
const isMobile = bowser.mobile || bowser.tablet;

const SLIDER_MIN = 0;
const SLIDER_MAX = 80;
const SLIDER_STEP = 1;
const RESTRICTED_VALUE = 48;

const getPopoverProps = ({ imgSrc, title }) => ({
  imgSrc,
  renderContent: () => (
    <Paragraph appearance="white" size="small">
      {title}
    </Paragraph>
  ),
});

const getValuePopoverProps = (restrictedValue) => ({
  renderContent: () => {
    const desktopMessage = i18next.t(
      'Note: Gap over {value} will be scaled down on tablets and mobile devices.',
      { value: `${restrictedValue}px` }
    );
    const mobileMessage = i18next.t('Note: Gap over {value} will only be shown on desktop.', {
      value: `${restrictedValue}px`,
    });

    return (
      <Paragraph appearance="white" size="small">
        {isMobile ? mobileMessage : desktopMessage}
      </Paragraph>
    );
  },
  checkVisibility: (value) => value > restrictedValue,
});

const getVerticalGap = (settingId, settings = {}) => ({
  ...settings,
  id: controlIds.VERTICAL_GAP,
  attributes: [attributes.ROW_GAP],
  iconGlyph: 'gap-horizontal',
  title: i18next.t('Vertical gap'),
  computeFallbackValue: computeSpacingFallback,
  mixedLabel: i18next.t('Mixed'),
  step: SLIDER_STEP,
  min: SLIDER_MIN,
  max: SLIDER_MAX,
  popover: getPopoverProps({
    imgSrc: previewGifs.COLUMNS_VERTICAL_GAP_GIF,
    title: i18next.t('Adjust the vertical spacing between columns'),
  }),
  valuePopover: getValuePopoverProps(RESTRICTED_VALUE),
});

export default getVerticalGap;
